import React from 'react';
import { skillsData } from '../data/mockData';
import { Progress } from './ui/progress';

const Skills = () => {
  return (
    <section id="skills" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-emerald-600 font-medium text-sm tracking-wide uppercase">
            Skills & Expertise
          </span>
          <h2 className="text-3xl sm:text-4xl font-light text-gray-900 mt-2">
            Technologies I{' '}
            <span className="font-semibold">Work With</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-16">
          {/* Primary Skills with Progress */}
          <div>
            <h3 className="text-xl font-semibold text-gray-900 mb-8">
              Core Technologies
            </h3>
            <div className="space-y-6">
              {skillsData.primary.map((skill, index) => (
                <div key={index} className="group">
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-gray-700 font-medium">{skill.name}</span>
                    <span className="text-sm text-emerald-600 font-medium">{skill.level}%</span>
                  </div>
                  <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-full transition-all duration-1000 ease-out"
                      style={{ width: `${skill.level}%` }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Secondary Skills & Tools */}
          <div className="space-y-12">
            {/* Frameworks & Libraries */}
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-6">
                Frameworks & Libraries
              </h3>
              <div className="flex flex-wrap gap-3">
                {skillsData.secondary.map((skill, index) => (
                  <span
                    key={index}
                    className="px-4 py-2 bg-white border border-gray-200 text-gray-700 rounded-lg text-sm font-medium hover:border-emerald-300 hover:bg-emerald-50 transition-all duration-200 cursor-default"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>

            {/* Tools & Platforms */}
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-6">
                Tools & Platforms
              </h3>
              <div className="flex flex-wrap gap-3">
                {skillsData.tools.map((tool, index) => (
                  <span
                    key={index}
                    className="px-4 py-2 bg-gray-900 text-white rounded-lg text-sm font-medium hover:bg-gray-800 transition-colors cursor-default"
                  >
                    {tool}
                  </span>
                ))}
              </div>
            </div>

            {/* Languages */}
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-6">
                Programming Languages
              </h3>
              <div className="grid grid-cols-2 gap-4">
                {['JavaScript', 'TypeScript', 'Java', 'Go Lang', 'C/C++', 'HTML/CSS'].map((lang, index) => (
                  <div
                    key={index}
                    className="flex items-center space-x-3 p-3 bg-white rounded-lg border border-gray-100"
                  >
                    <div className="w-2 h-2 bg-emerald-500 rounded-full" />
                    <span className="text-gray-700 font-medium text-sm">{lang}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
